module.exports = __webpack_public_path__ + "static/img/manual-26.2732261.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-26.png
// module id = 58HR
// module chunks = 4